import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import AIChatPopup from './AIChatPopup';

const ContactChannels = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  const channels = [
    {
      id: 1,
      icon: "MessageSquare",
      title: "Живой чат",
      description: "Мгновенная поддержка через AI-чат с приоритетным ответом в течение 2 минут",
      availability: "Онлайн сейчас",
      action: "Начать чат",
      color: "accent",
      available: true,
      onClick: () => setIsChatOpen(true)
    },
    {
      id: 2,
      icon: "Mail",
      title: "Email поддержка",
      description: "Подробные ответы на технические вопросы и запросы интеграции",
      availability: "Ответ в течение 2 часов",
      action: "Написать письмо",
      email: "info@ai.jetu.pro",
      color: "primary",
      available: true,
      link: "mailto:info@ai.jetu.pro"
    },
    {
      id: 3,
      icon: "Phone",
      title: "Телефон",
      description: "Прямая связь с экспертами для срочных вопросов и консультаций",
      availability: "Пн-Пт 9:00-18:00 (GMT+6)",
      action: "Позвонить",
      phone: "+77476660065",
      color: "success",
      available: true,
      link: "tel:+77476660065"
    },
    {
      id: 4,
      icon: "MessageCircle",
      title: "WhatsApp Business",
      description: "Удобная поддержка через мессенджер с возможностью отправки файлов",
      availability: "24/7 автоответчик",
      action: "Открыть WhatsApp",
      color: "success",
      available: true,
      link: "https://wa.me/77476660065"
    },
    {
      id: 5,
      icon: "Video",
      title: "Видеоконсультация",
      description: "Персональная демонстрация функций и помощь в настройке системы",
      availability: "По предварительной записи",
      action: "Записаться",
      color: "primary",
      available: true,
      link: "https://wa.me/77476660065"
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      accent: "bg-accent/10 text-accent border-accent/20",
      primary: "bg-primary/10 text-primary border-primary/20",
      success: "bg-success/10 text-success border-success/20"
    };
    return colors?.[color] || colors?.accent;
  };

  const handleChannelClick = (channel) => {
    if (channel?.onClick) {
      channel?.onClick();
    } else if (channel?.link) {
      window.open(channel?.link, '_blank');
    }
  };

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-headline font-bold text-foreground mb-4">
            Выберите удобный канал связи
          </h2>
          <p className="text-lg text-muted-foreground">
            Мы предлагаем множество способов связи, чтобы вы могли получить помощь наиболее удобным для вас способом
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {channels?.map((channel) => (
            <div
              key={channel?.id}
              className="bg-card border border-border rounded-2xl p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className={`w-14 h-14 rounded-xl ${getColorClasses(channel?.color)} border flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={channel?.icon} size={28} />
              </div>

              <h3 className="text-xl font-headline font-semibold text-foreground mb-2">
                {channel?.title}
              </h3>

              <p className="text-muted-foreground text-sm mb-4 leading-relaxed">
                {channel?.description}
              </p>

              <div className="flex items-center space-x-2 mb-4">
                <div className={`w-2 h-2 rounded-full ${channel?.available ? 'bg-success' : 'bg-muted'} animate-pulse`}></div>
                <span className="text-sm text-muted-foreground">{channel?.availability}</span>
              </div>

              {channel?.email && (
                <p className="text-sm text-accent mb-4 font-medium">{channel?.email}</p>
              )}

              {channel?.phone && (
                <p className="text-sm text-accent mb-4 font-medium">{channel?.phone}</p>
              )}

              <Button
                variant="outline"
                fullWidth
                iconName="ArrowRight"
                iconPosition="right"
                onClick={() => handleChannelClick(channel)}
              >
                {channel?.action}
              </Button>
            </div>
          ))}
        </div>
      </div>

      <AIChatPopup isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
    </section>
  );
};

export default ContactChannels;